module.exports = __webpack_public_path__ + "static/media/anon-UX.66b7cd2c.png";